// extracted by mini-css-extract-plugin
export default {"newOpportunity":"newOpportunityBadge_newOpportunity__KTiOs"};